










import { Vue, Component } from 'vue-property-decorator'
import ConnectToSpotify from '@/components/party/library/ConnectToSpotify.vue'
import SubLibrary from '@/components/party/library/SubLibrary.vue'
@Component({
  components: { SubLibrary, ConnectToSpotify }
})
export default class Library extends Vue {
  get isConnectedToSpotify () {
    return this.$store.state.user.hasAuthorizedSpotify && this.$store.state.user.refreshToken
  }
}
